import {
  AfterViewChecked,
  AfterViewInit,
  Directive, DoCheck,
  ElementRef,
  HostListener, Input,
  Renderer2
} from '@angular/core';
import {CalculateTableHeightService} from "../core/calculate-table-height.service";

@Directive({
  selector: '[dynamicGrid]'
})
export class GridResizeDirective implements AfterViewInit, AfterViewChecked {

  /**
   * The selector decorator of the main content, declared under @Component in each component.
   * Used as HTML tag name to query the HTML element of the component in DOM tree.
   */
  @Input('selector') selector: string;

  /**
   * Reference the #tableContainer element.
   * Use Renderer2 to adjust the styling of this element.
   */
  @Input('tableContainerElement') tableContainerElement: any;

  private tableRendered: boolean = false;

  constructor(private elementRef: ElementRef,
              private renderer: Renderer2,
              private calculateTableHeightService: CalculateTableHeightService) {
  }
  /**
   * Set initial table height after all elements render
   */
  ngAfterViewInit() {
    this.adjustHeight()
    // console.log('Component Tag Name:', this.selector);
    // console.log(this.tableContainerElement.className);
    // console.log(document.querySelector(`${this.selector}`))

  }

  /**
   * Check for table render event in search screens. If
   */
  ngAfterViewChecked() {
    if (!this.tableRendered && this.tableContainerElement.querySelector('table')) {
      this.tableRendered = true
      this.adjustHeight();
    } else if (!this.tableContainerElement.querySelector('table')) {
      this.tableRendered = false;
    }
  }

  /**
   * Listen for screen size change and update table height accordingly
   */
  @HostListener('window:resize')
  onWindowResize() {
    this.adjustHeight();
  }



  private adjustHeight() {
    let height = this.calculateTableHeightService.calculateTabletHeight(this.selector, this.tableContainerElement.className);
    this.renderer.setStyle(this.tableContainerElement, "height", `${height}px`);
  }
}
